module.exports = __webpack_public_path__ + "static/media/secondary-3-literary.cd4ad7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/secondary-3-literary.png
// module id = 172
// module chunks = 0